var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Wrapper"},[_c('HStack',{attrs:{"pstyle":{
      justifyContent: 'center',
      minWidth: '61px',
      maxWidth: '61px',
      marginRight: '1em',
    }}},[_c('img',{attrs:{"src":require(("../../../assets/" + _vm.svg))}})]),_c('div',{staticClass:"TextParent"},[_c('div',{staticClass:"Title"},[_vm._v(" "+_vm._s(_vm.text.header)+" ")]),_c('div',{staticClass:"Text"},[_vm._v(_vm._s(_vm.text.text))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }